import { useMutation, gql } from "@apollo/client"
import { CATEGORIES_FIELDS } from "./useQueryCategories"

const CREATECATEGORY_MUTATION = gql`
  mutation CreateCategory($name: String!, $description: String, $icon: String!, $groups: [ID!], $locations: [ID!]) {
    createCategory(name: $name, description: $description, icon: $icon, groups: $groups, locations: $locations) {
      ${CATEGORIES_FIELDS}
    } 
  }
`

const useMutationCreateCategory = () => useMutation(CREATECATEGORY_MUTATION)

export { useMutationCreateCategory }
